
export class PlanGoodsNutritionDetailModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * アイテムコード共通
   */
  // アイテムコード
  public itemCode: string = <string>'';

  /**
   * アイテムコード環境
   */
  // 分析連番
  public analysisSeqNo: string = <string>'';

  /**
   * アイテムコード、分析単位環境
   */
  // 栄養成分コード
  public nutritionalCode: string = <string>'';

  // 栄養成分量
  public nutritionalQuantity: string = <string>'';

  // メンテナンス種別
  public maintenanceDivQuantity: string = <string>'';

  // 画面表示用データ項目名
  public itemNameForForm: string = <string>'';
}